/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RelationsControllerDeleteById200ResponseData { 
    relationId?: string;
    outcome?: RelationsControllerDeleteById200ResponseData.OutcomeEnum;
    mirrorId?: string | null;
    mirrorOutcome?: RelationsControllerDeleteById200ResponseData.MirrorOutcomeEnum | null;
}
export namespace RelationsControllerDeleteById200ResponseData {
    export type OutcomeEnum = 'ended' | 'deleted';
    export const OutcomeEnum = {
        Ended: 'ended' as OutcomeEnum,
        Deleted: 'deleted' as OutcomeEnum
    };
    export type MirrorOutcomeEnum = 'ended' | 'deleted';
    export const MirrorOutcomeEnum = {
        Ended: 'ended' as MirrorOutcomeEnum,
        Deleted: 'deleted' as MirrorOutcomeEnum
    };
}


